import { useRef } from 'react';
import { Box } from '@doist/marketist';
import { useTranslation } from 'next-i18next';
import css from './iframe-preview.module.css';
import type { TemplatePreview } from 'services/templates/types';
const APP_DOMAIN = process.env.NEXT_PUBLIC_APP_ENV === 'production' ? 'todoist.com' : 'staging.todoist.com';
export type IframePreviewProps = {
  template: TemplatePreview;
  iframeBlockSize?: string;
};
export function IframePreview({
  template,
  iframeBlockSize = '800px'
}: IframePreviewProps) {
  const {
    i18n,
    t
  } = useTranslation('templates');
  const $iframe = useRef<HTMLIFrameElement>(null);
  const webAppLang = i18n.language.replace('-', '_');
  const iframeURL = new URL('/app/template/preview', `https://${APP_DOMAIN}`);
  iframeURL.searchParams.set('template_id', template.id);
  iframeURL.searchParams.set('locale', webAppLang);
  iframeURL.searchParams.set('template_type', template.template_type);
  if (template.view_type) {
    iframeURL.searchParams.set('view_type', template.view_type);
  }
  return <Box className={css.iframePreview} style={{
    blockSize: iframeBlockSize
  }} data-sentry-element="Box" data-sentry-component="IframePreview" data-sentry-source-file="iframe-preview.tsx">
            <iframe ref={$iframe} src={iframeURL.toString()} title={t('previewOfTemplate', {
      name: template.name
    })} />
        </Box>;
}